import { FormControl, FormLabel, Select, Text } from "@chakra-ui/react";
import { InputProps } from "../Input";
interface Props extends InputProps {
  icon?: any;
  buttonText?: string;
  tooltipButtonText?: string;
  buttonfunction?: any;
  label?: string;
  disabled?: boolean;
  buttonDisabled?: boolean;
  width?: string;
  buttonFunction?: () => void;
  color?: any;
}

export function SelectButtonV2({
  icon,
  buttonText,
  tooltipButtonText,
  label,
  buttonfunction,
  errors,
  disabled = false,
  buttonDisabled = false,
  buttonFunction,
  width,
  color,
  register,
  labelColor = "var(--gray-400)",
  children,
  displayLabel = true,
  ...rest
}: Props) {
  return (
    <FormControl 
        maxW="100%"
        isInvalid={!!errors?.message}
    >
      <FormLabel 
          w="100%"
          color={labelColor ? labelColor : "gray.400"}
          fontSize="12px"
          visibility={displayLabel ? "visible" : "hidden"}
      >
          {label}
      </FormLabel>
      <Select 
        placeholder="Selecione o tipo" 
        color="gray.500" 
        borderRadius="2px"
        {...register}
        isDisabled={disabled}
        _hover={{
            cursor: disabled ? "not-allowed" : "pointer"
        }}
      >
        {children}    
      </Select>
      {errors && (
        <Text color="danger" role="alert">
          {errors.message}
        </Text>
      )}
    </FormControl>
  )
}